export const companyCodeConvert = (code) => {
  if (code.includes("LG에너지솔루션")) {
    return "LGES";
  } else {
    return "LG";
  }
  // if (code === "LGES") return "LGES";
  // else if (code === "LGIT") return "LGIT";
  // else return "LG";
};
